import ScrollHint from "scroll-hint";

new ScrollHint(".js-scrollable", {
  i18n: {
    scrollable: "スクロールできます",
  },
});
